import { render, staticRenderFns } from "./data-facturas.vue?vue&type=template&id=5f111ef1"
import script from "./data-facturas.vue?vue&type=script&lang=js"
export * from "./data-facturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports